import React from 'react';

function KamAddIcon() {
  return (
    <svg
      height="23.2"
      style={{ display: 'block' }}
      viewBox="0 0 25.297 23.2"
      width="25.297"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(.6 .6)">
        <g>
          <g
            data-name="Groupe 1568"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          >
            <path
              d="M21 22a19.928 19.928 0 00-2.282-7.572 6.832 6.832 0 00-2.276-2.328c-2.277-1.424-9.664-1.244-11.888 0a7.832 7.832 0 00-3.246 4.406A31.652 31.652 0 000 22zM14.632 4.083A4.1 4.1 0 1110.515 0h.019a4.091 4.091 0 014.098 4.083z"
              data-name="Tracé 218"
            />
            <path d="M0 5.785L0 0" data-name="Ligne 231" transform="translate(6.322 16.214)" />
            <path d="M0 5.785L0 0" data-name="Ligne 232" transform="translate(14.632 16.214)" />
          </g>
        </g>
        <path
          d="M0 0L0 6.197"
          data-name="Ligne 322"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
          transform="translate(21 2.03)"
        />
        <path
          d="M6.197 0L0 0"
          data-name="Ligne 323"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
          transform="translate(17.901 5.128)"
        />
      </g>
    </svg>
  );
}

export default KamAddIcon;
